import defaultPageStyles from "src/assets/jss/material-kit-react/defaultPageStyles"

const privacyPageStyles = theme => ({
  body: {
    ...defaultPageStyles
  }
})

export default privacyPageStyles
